import { Injectable, EventEmitter } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { environment } from '../../../environments/environment.prod';
import { ICarrierCertificate } from '../objects/carrier/carrierCertificate';

@Injectable()
export class CertificatesHubService {
  expiredCertificatesEmitter: EventEmitter<number> = new EventEmitter<number>();
  certificateEmitter: EventEmitter<ICarrierCertificate> = new EventEmitter<ICarrierCertificate>();
  private hubConnection: signalR.HubConnection;
  constructor() { }

  connectToHubWithAutoConnect(): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.baseUrl}/${environment.certificatesHubUrl}`)
      .build();

    this.hubConnection.on('SendExpiredCertificates', (expired: number) => {
      this.expiredCertificatesEmitter.next(expired);
    });

    this.hubConnection.on('SendCertificate', (certificate: ICarrierCertificate) => {
      this.certificateEmitter.next(certificate);
    });

    this.hubConnection
      .start()
      .then(() => {
        console.log('Hub connection started');
      })
      .catch(err => {
        console.log('Error while establishing connection' + err);
      });

    this.hubConnection.onclose(err => {
      console.log('Hub connection lost ' + err);
      this.hubConnection
        .start()
        .then(() => {
          console.log('Hub connection restarted');
        })
        .catch(error => {
          console.log('Error while reconnecting to the hub ' + error);
        });
    });

    this.hubConnection.keepAliveIntervalInMilliseconds = 30000;
    this.hubConnection.serverTimeoutInMilliseconds = 60000;
  }

  connectToHub(): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(
        `${environment.baseUrl}/${environment.certificatesHubUrl}`
      )
      .build();

    this.hubConnection.on('SendExpiredCertificates', (expired: number) => {
      this.expiredCertificatesEmitter.next(expired);
    });

    this.hubConnection.on('SendCertificate', (certificate: ICarrierCertificate) => {
      this.certificateEmitter.next(certificate);
    });


    this.hubConnection
      .start()
      .then(() => {
        console.log('Hub connection started');
      })
      .catch(err => {
        console.log('Error while establishing connection' + err);
      });

    this.hubConnection.keepAliveIntervalInMilliseconds = 30000;
    this.hubConnection.serverTimeoutInMilliseconds = 60000;
  }

  disconnectFromHub(): void {
    if (!!this.hubConnection) {
      this.hubConnection.onclose(disconnect => {
        console.log('Hub connection stopped');
      });
      this.hubConnection.stop();
    }
  }
}
